"use client";
import React, { useState } from "react";
import MainStates from "./MainStates";
// import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/20/solid'
import Image from "next/image";
import Seemore from "../../../public/updated-home/car-service/seemore.svg";
import Seeless from "../../../public/updated-home/car-service/seeless.svg";
import Link from "next/link";
// console.log(MyData, 'sssss');
import style from "@/app/style/state.module.css";

function allstate() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div>
      <div className=" mb-10">
        <div className="mx-auto max-w-7xl ">
          {/* Content goes here */}
          <div className="mx-auto px-7  mt-10 sm:max-w-7xl  md:max-w-6xl    lg:max-w-7xl xl:text-center">
            <h2 className=" text-3xl  font-bold secondary">
              <span style={{ color: "#D5AF34" }}>
                {" "}
                Discover Prestige Ride:{" "}
              </span>
              <br />
              <span style={{ color: "#2B3252" }}>
                Your Nationwide Luxury Transportation Partner
              </span>
            </h2>

            <p className="updatedparapremu pt-3 mb-12 leading-7">
              In a world where convenience, luxury, and reliability are more
              sought after than ever,{" "}
              <a id="highlight" href="/">
                {" "}
                Prestige Ride
              </a>
              stands as a beacon of excellence in the transportation industry.
              As a leader in offering luxurious and dependable black car
              services across all states, we are your ideal partner for
              unparalleled transportation services. Let’s delve deeper to
              discover why Prestige Ride should be your first choice.{" "}
            </p>
          </div>
          {/* ============================================================================================== */}

          <div className="mx-auto max-w-7xl">
            <MainStates />
          </div>
        </div>
      </div>
    </div>
  );
}

export default allstate;
